// extracted by mini-css-extract-plugin
module.exports = {"container":"FailedPayment_container_3AlNp","image":"FailedPayment_image_2GjyD"};